import styles from "./DiagonalLabel.module.css";

export function DiagonalLabel({ text = <>Melanie Brücher-Kümmel<br />Geschäftsführerin</> }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.line} />
      <span className={styles.text}>{text}</span>
    </div>
  );
}
